(() => {
  const PANEL_SELECTOR =
    "[data-joans-notion-purchase]";

  function initialisePanels(root = document) {
    root
      .querySelectorAll(PANEL_SELECTOR)
      .forEach(initialisePanel);
  }

  function initialisePanel(panel) {
    if (
      panel.dataset.joansNotionInitialised ===
      "true"
    ) {
      return;
    }

    const productForm = panel.closest("form");

    const productDetails =
      panel.closest(".product-details");

    const variantsScript =
      panel.querySelector(
        "[data-joans-notion-variants]"
      );

    const optionGroups = Array.from(
      panel.querySelectorAll(
        "[data-joans-notion-option]"
      )
    );

    const optionButtons = Array.from(
      panel.querySelectorAll(
        "[data-joans-notion-option-button]"
      )
    );

    const minusButton =
      panel.querySelector(
        "[data-joans-notion-minus]"
      );

    const plusButton =
      panel.querySelector(
        "[data-joans-notion-plus]"
      );

    const quantityDisplay =
      panel.querySelector(
        "[data-joans-notion-quantity]"
      );

    const priceDisplay =
      panel.querySelector(
        "[data-joans-notion-price]"
      );

    const totalDisplay =
      panel.querySelector(
        "[data-joans-notion-total]"
      );

    const addButton =
      panel.querySelector(
        "[data-joans-notion-add]"
      );

    const message =
      panel.querySelector(
        "[data-joans-notion-message]"
      );

    /*
     * Do not hide Horizon's native controls unless every
     * essential part of the Joan's panel is present.
     */

    if (
      !productForm ||
      !variantsScript ||
      !minusButton ||
      !plusButton ||
      !quantityDisplay ||
      !priceDisplay ||
      !totalDisplay ||
      !addButton
    ) {
      console.error(
        "Joan's: notion purchase panel is incomplete."
      );

      return;
    }

    let variants = [];

    try {
      variants = JSON.parse(
        variantsScript.textContent
      );
    } catch (error) {
      console.error(
        "Joan's: notion variant data could not be read.",
        error
      );

      return;
    }

    if (
      !Array.isArray(variants) ||
      variants.length === 0
    ) {
      console.error(
        "Joan's: no notion variants were found."
      );

      return;
    }

        const nativeVariantInput =
      productForm.querySelector(
        'input[name="id"]'
      );

    /*
     * Keep Joan's custom option buttons connected to
     * Horizon's native variant picker.
     */
    const nativeVariantPicker =
      productDetails?.querySelector(
        "variant-picker"
      ) || null;

    let nativeQuantityInput =
      productForm.querySelector(
        'input[name="quantity"]'
      );

    /*
     * Some Horizon product forms do not output a visible
     * quantity input when that block is disabled. Add a hidden
     * one so the native product form remains valid.
     */

    if (!nativeQuantityInput) {
      nativeQuantityInput =
        document.createElement("input");

      nativeQuantityInput.type = "hidden";
      nativeQuantityInput.name = "quantity";
      nativeQuantityInput.value = "1";

      productForm.appendChild(
        nativeQuantityInput
      );
    }

    const productId =
      String(
        panel.dataset.productId || ""
      );

    const currency =
      panel.dataset.currency || "NZD";

    const initialVariantId =
      String(
        panel.dataset.initialVariantId || ""
      );

    const selectedOptions = [];

    let currentVariant =
      variants.find(
        (variant) =>
          String(variant.id) ===
          initialVariantId
      ) || variants[0];

    let quantity = 1;
    let isAdding = false;

    const moneyFormatter =
      new Intl.NumberFormat(
        document.documentElement.lang ||
          "en-NZ",
        {
          style: "currency",
          currency,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }
      );

    function formatMoney(cents) {
      const numericCents =
        Number(cents) || 0;

      return moneyFormatter.format(
        numericCents / 100
      );
    }

    function setMessage(
      text = "",
      isError = false
    ) {
      if (!message) {
        return;
      }

      message.textContent = text;

      message.style.color = isError
        ? "#8a3324"
        : "";
    }

    function getVariantMinimum(variant) {
      return Math.max(
        1,
        Number(
          variant?.quantityMinimum
        ) || 1
      );
    }

    function getVariantIncrement(variant) {
      return Math.max(
        1,
        Number(
          variant?.quantityIncrement
        ) || 1
      );
    }

    function getVariantMaximum(variant) {
      if (!variant) {
        return null;
      }

      const possibleMaximums = [];

      const quantityMaximum =
        Number(variant.quantityMaximum);

      if (
        Number.isFinite(quantityMaximum) &&
        quantityMaximum > 0
      ) {
        possibleMaximums.push(
          quantityMaximum
        );
      }

      const inventoryQuantity =
        Number(
          variant.inventoryQuantity
        );

      if (
        variant.inventoryManagement ===
          "shopify" &&
        variant.inventoryPolicy ===
          "deny" &&
        Number.isFinite(
          inventoryQuantity
        )
      ) {
        possibleMaximums.push(
          Math.max(
            0,
            inventoryQuantity
          )
        );
      }

      if (
        possibleMaximums.length === 0
      ) {
        return null;
      }

      return Math.min(
        ...possibleMaximums
      );
    }

    function getHighestValidQuantity(
      variant
    ) {
      const minimum =
        getVariantMinimum(variant);

      const increment =
        getVariantIncrement(variant);

      const maximum =
        getVariantMaximum(variant);

      if (maximum === null) {
        return null;
      }

      if (maximum < minimum) {
        return 0;
      }

      const incrementsAvailable =
        Math.floor(
          (maximum - minimum) /
            increment
        );

      return (
        minimum +
        incrementsAvailable * increment
      );
    }

    function normaliseQuantity(
      requestedQuantity,
      variant
    ) {
      const minimum =
        getVariantMinimum(variant);

      const increment =
        getVariantIncrement(variant);

      const highestValid =
        getHighestValidQuantity(
          variant
        );

      let normalised =
        Number(requestedQuantity);

      if (
        !Number.isFinite(normalised)
      ) {
        normalised = minimum;
      }

      normalised = Math.max(
        minimum,
        normalised
      );

      const steps =
        Math.round(
          (normalised - minimum) /
            increment
        );

      normalised =
        minimum +
        steps * increment;

      if (
        highestValid !== null
      ) {
        normalised = Math.min(
          normalised,
          highestValid
        );
      }

      return Math.max(
        0,
        normalised
      );
    }

    function initialiseSelectedOptions() {
      optionGroups.forEach(
        (group) => {
          const position =
            Number(
              group.dataset
                .optionPosition
            ) - 1;

          const selectedButton =
            group.querySelector(
              ".is-selected"
            ) ||
            group.querySelector(
              "[data-joans-notion-option-button]"
            );

          if (
            position >= 0 &&
            selectedButton
          ) {
            selectedOptions[position] =
              selectedButton.dataset
                .optionValue;
          }
        }
      );

      if (
        currentVariant?.options
      ) {
        currentVariant.options.forEach(
          (value, index) => {
            if (
              selectedOptions[index] ===
              undefined
            ) {
              selectedOptions[index] =
                value;
            }
          }
        );
      }
    }

    function findSelectedVariant() {
      if (
        optionGroups.length === 0
      ) {
        return (
          variants.find(
            (variant) =>
              String(variant.id) ===
              String(
                currentVariant?.id
              )
          ) || variants[0]
        );
      }

      return (
        variants.find((variant) => {
          if (
            !Array.isArray(
              variant.options
            )
          ) {
            return false;
          }

          return selectedOptions.every(
            (selectedValue, index) =>
              String(
                variant.options[index]
              ) ===
              String(selectedValue)
          );
        }) || null
      );
    }

    function updateOptionButtons() {
      optionButtons.forEach(
        (button) => {
          const position =
            Number(
              button.dataset
                .optionPosition
            ) - 1;

          const isSelected =
            String(
              selectedOptions[position]
            ) ===
            String(
              button.dataset
                .optionValue
            );

          button.classList.toggle(
            "is-selected",
            isSelected
          );

          button.setAttribute(
            "aria-pressed",
            isSelected
              ? "true"
              : "false"
          );
        }
      );
    }

    function syncNativeForm() {
      if (
        currentVariant &&
        nativeVariantInput
      ) {
        nativeVariantInput.value =
          String(currentVariant.id);
      }

      nativeQuantityInput.value =
        String(quantity);
    }

        function syncHorizonVariantPicker(button) {
      if (!nativeVariantPicker || !button) {
        return;
      }

      const optionPosition =
        String(
          button.dataset.optionPosition || ""
        );

      const optionValue =
        String(
          button.dataset.optionValue || ""
        );

      if (!optionPosition || !optionValue) {
        return;
      }

      const nativeChoices =
        Array.from(
          nativeVariantPicker.querySelectorAll(
            `[data-input-id^="${optionPosition}-"]`
          )
        );

      const nativeChoice =
        nativeChoices.find(
          (choice) =>
            String(choice.value) ===
            optionValue
        );

      if (
        nativeChoice instanceof
        HTMLInputElement
      ) {
        if (!nativeChoice.checked) {
          nativeChoice.click();
        }

        return;
      }

      if (
        nativeChoice instanceof
        HTMLOptionElement
      ) {
        const nativeSelect =
          nativeChoice.closest("select");

        if (!nativeSelect) {
          return;
        }

        if (
          String(nativeSelect.value) !==
          optionValue
        ) {
          nativeSelect.value =
            nativeChoice.value;

          nativeSelect.dispatchEvent(
            new Event(
              "change",
              { bubbles: true }
            )
          );
        }
      }
    }

    function updateQuantityButtons() {
      if (!currentVariant) {
        minusButton.disabled = true;
        plusButton.disabled = true;
        return;
      }

      const minimum =
        getVariantMinimum(
          currentVariant
        );

      const increment =
        getVariantIncrement(
          currentVariant
        );

      const highestValid =
        getHighestValidQuantity(
          currentVariant
        );

      minusButton.disabled =
        quantity - increment <
        minimum;

      plusButton.disabled =
        highestValid !== null &&
        quantity + increment >
          highestValid;
    }

    function variantCanBePurchased() {
      if (
        !currentVariant ||
        !currentVariant.available
      ) {
        return false;
      }

      const highestValid =
        getHighestValidQuantity(
          currentVariant
        );

      return highestValid !== 0;
    }

    function updateAddButton() {
      if (isAdding) {
        addButton.disabled = true;
        addButton.textContent =
          "Adding…";
        return;
      }

      if (!currentVariant) {
        addButton.disabled = true;
        addButton.textContent =
          "Unavailable";
        return;
      }

      if (
        !variantCanBePurchased()
      ) {
        addButton.disabled = true;
        addButton.textContent =
          "Sold out";
        return;
      }

      addButton.disabled = false;
      addButton.textContent =
        "Add to cart";
    }

    function updatePanel() {
      updateOptionButtons();

      if (!currentVariant) {
        priceDisplay.textContent =
          "Unavailable";

        totalDisplay.textContent =
          "Unavailable";

        quantityDisplay.textContent =
          String(quantity);

        updateQuantityButtons();
        updateAddButton();
        syncNativeForm();

        return;
      }

      quantity = normaliseQuantity(
        quantity,
        currentVariant
      );

      const unitPrice =
        Number(
          currentVariant.price
        ) || 0;

      priceDisplay.textContent =
        formatMoney(unitPrice);

      totalDisplay.textContent =
        formatMoney(
          unitPrice * quantity
        );

      quantityDisplay.textContent =
        String(quantity);

      updateQuantityButtons();
      updateAddButton();
      syncNativeForm();
    }

    function selectOption(button) {
      const position =
        Number(
          button.dataset
            .optionPosition
        ) - 1;

      if (position < 0) {
        return;
      }

      selectedOptions[position] =
        button.dataset.optionValue;

      currentVariant =
        findSelectedVariant();

      if (currentVariant) {
        quantity =
          normaliseQuantity(
            quantity,
            currentVariant
          );

        setMessage("");
      } else {
        setMessage(
          "This option combination is unavailable.",
          true
        );
      }

            updatePanel();

      /*
       * Pass the same selection to Horizon so the
       * variant image/gallery updates too.
       */
      syncHorizonVariantPicker(button);
    }

    async function addUsingHorizon() {
      const updateCart =
        window.Shopify?.actions
          ?.updateCart;

      const openCart =
        window.Shopify?.actions
          ?.openCart;

      if (
        typeof updateCart !==
          "function" ||
        typeof openCart !==
          "function"
      ) {
        return false;
      }

      const result =
        await updateCart(
          {
            lines: [
              {
                merchandiseId:
                  String(
                    currentVariant.id
                  ),

                quantity,
              },
            ],
          },
          {
            event: {
              context: "product",
              detail: {
                source:
                  "joans-notion",
                productId,
              },
            },
          }
        );

      if (
        result?.userErrors?.length
      ) {
        throw new Error(
          result.userErrors[0]
            .message ||
            "This item could not be added."
        );
      }

      if (
        result?.warnings?.length
      ) {
        console.warn(
          "Joan's: notion cart warning",
          result.warnings
        );
      }

      await openCart();

      return true;
    }

    async function addUsingAjax() {
      const cartRoot =
        window.Shopify?.routes
          ?.root || "/";

      const response = await fetch(
        `${cartRoot}cart/add.js`,
        {
          method: "POST",
          headers: {
            "Content-Type":
              "application/json",
            Accept:
              "application/json",
          },
          credentials:
            "same-origin",
          body: JSON.stringify({
            items: [
              {
                id:
                  currentVariant.id,
                quantity,
              },
            ],
          }),
        }
      );

      const responseData =
        await response.json();

      if (
        !response.ok ||
        responseData.status
      ) {
        throw new Error(
          responseData.description ||
            responseData.message ||
            "This item could not be added."
        );
      }

      const openCart =
        window.Shopify?.actions
          ?.openCart;

      if (
        typeof openCart ===
        "function"
      ) {
        await openCart();
      } else {
        window.location.assign(
          `${cartRoot}cart`
        );
      }
    }

    async function addToCart() {
      if (
        isAdding ||
        !variantCanBePurchased()
      ) {
        return;
      }

      isAdding = true;
      setMessage("");
      updateAddButton();

      try {
        const usedHorizon =
          await addUsingHorizon();

        if (!usedHorizon) {
          await addUsingAjax();
        }

        addButton.textContent =
          "Added to cart";

        setMessage(
          "Added to your cart."
        );

        window.setTimeout(() => {
          isAdding = false;
          setMessage("");
          updateAddButton();
        }, 1400);
      } catch (error) {
        console.error(
          "Joan's: notion add to cart failed",
          error
        );

        isAdding = false;

        setMessage(
          error instanceof Error
            ? error.message
            : "This item could not be added. Please try again.",
          true
        );

        updateAddButton();
      }
    }

    initialiseSelectedOptions();

    currentVariant =
      findSelectedVariant() ||
      currentVariant;

    quantity =
      getVariantMinimum(
        currentVariant
      );

    optionButtons.forEach(
      (button) => {
        button.addEventListener(
          "click",
          () => {
            selectOption(button);
          }
        );
      }
    );

    minusButton.addEventListener(
      "click",
      () => {
        if (!currentVariant) {
          return;
        }

        quantity -=
          getVariantIncrement(
            currentVariant
          );

        quantity =
          normaliseQuantity(
            quantity,
            currentVariant
          );

        setMessage("");
        updatePanel();
      }
    );

    plusButton.addEventListener(
      "click",
      () => {
        if (!currentVariant) {
          return;
        }

        const proposedQuantity =
          quantity +
          getVariantIncrement(
            currentVariant
          );

        const highestValid =
          getHighestValidQuantity(
            currentVariant
          );

        if (
          highestValid !== null &&
          proposedQuantity >
            highestValid
        ) {
          return;
        }

        quantity =
          normaliseQuantity(
            proposedQuantity,
            currentVariant
          );

        setMessage("");
        updatePanel();
      }
    );

    addButton.addEventListener(
      "click",
      addToCart
    );

    /*
     * Everything required is now connected. It is safe to hide
     * Horizon's duplicate controls.
     */

    panel.dataset.joansNotionInitialised =
      "true";

    productForm.classList.add(
      "joans-notion-form--enhanced"
    );

    if (productDetails) {
      productDetails.classList.add(
        "joans-notion-product--enhanced"
      );
    }

    updatePanel();
  }

  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      () => initialisePanels()
    );
  } else {
    initialisePanels();
  }

  document.addEventListener(
    "shopify:section:load",
    (event) => {
      initialisePanels(event.target);
    }
  );
})();